// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-cell {
	display: table-cell;
	width: 319px; 
	vertical-align: top;
	background: #f3f3f3;
	border-right: 1px solid #d5d5d5;
	box-sizing: border-box;
	float: left;
	top: 0;
	padding-bottom: 13px;
	padding-right: 10px;
}

.left-rail {
	position: relative;
	display: block;
	width: 100%;
	padding: 0;
	overflow-y: auto;
	overflow-x: hidden;
	font-size: 1.3rem; 
}

.left-rail .dropdown button {
	height: 25px;
	font-size: 11px;
}

#thumbnail-pane .ui-resizable-e  {
	right: 0 !important;
	width: 10px !important;
	background: rgba(94,140,38, 0.10) !important;
}

.right-cell .ui-resizable-w  .handler, 
#thumbnail-pane .ui-resizable-e .handler {
	border-right: 2px;
	border-left: 2px;
	width: 5px; 
	height: 50px; 
    position: relative;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%); 
    
    border-style: solid;
    -webkit-border-image: 
      -webkit-gradient(linear, 0 0, 0 100%, from(var(--main-secondary)), to(var(--main-primary))) 10 100%;
    -webkit-border-image: 
      -webkit-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;
    -moz-border-image:
      -moz-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;    
    -o-border-image:
      -o-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;
    border-image:
      linear-gradient(to bottom, var(--main-secondary), var(--main-primary)) 0 100%;
}

@-moz-document url-prefix() {
	.left-rail {
		/*height: 87vh;*/
		-webkit-transition: height 0.5s;
		-moz-transition: height 0.5s;
		-ms-transition: height 0.5s;
		-o-transition: height 0.5s;
		transition: height 0.5s;
	}
}

@media screen and (max-height: 1200px) {
	@-moz-document url-prefix() {
		.left-rail {
			/*height: 77vh;*/
			-webkit-transition: height 0.5s;
			-moz-transition: height 0.5s;
			-ms-transition: height 0.5s;
			-o-transition: height 0.5s;
			transition: height 0.5s;
		}
	}
}

.search-filter {
	padding: 0;
}

.search-filter .search-box {
	width: 100%;
	font-size: 11px;
}

.filter-forms .dropdown {
	margin-top: 10px;
}

.add-page-expcol {
	padding: 7px 0 9px 10px;
	overflow: hidden;
	background: #ffffff;
}

.add-page-expcol .btn {
	text-align:left;
}

.add-page-expcol .btn:first-child {
	margin-right: 10px;
}

.add-page-expcol .btn i {
	font-size: 1.3rem;
	font-weight: bold;
	vertical-align: middle;
	color: #799F3F;
	margin-right: 3px;
}

.document-group {
	margin: 20px 0 0;
}

.document > .document-heading {
	padding: 0 15px;
	background: #f3f3f3;
	border-top: 1px solid #d5d5d5;
	overflow: hidden;
}

.document.active > .document-heading {
	background: var(--main-primary) !important; /* Old browsers */
	background: -moz-linear-gradient(var(--gradient)) !important; /* FF3.6-15 */
	background: -webkit-linear-gradient(var(--gradient)) !important; /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(var(--gradient-ToBottom)) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	
	border-top: 0;
	
	color: #fff;
}

.document > .document-heading > h4 {
	float: left;
	margin-top: 6px;
	margin-left: 15px;
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
	font-size: 14px;
	font-size: 1.4rem;
	letter-spacing: 0.2px;
	max-width: 85%;
	width: 85%;
	white-space: nowrap;
	overflow: hidden;
}

.document > .document-heading > h4 > a {
	color: #333;
}

.document > .document-heading > h4 > a:visited, .document > .document-heading > h4 > a:active {
	text-decoration: none !important;
}

.document > .document-heading > h4 > a:hover {
	text-decoration: none;
}


.document.active > .document-heading > h4 > a {
	color: #fff;
}

.document > .document-heading .switch {
	float: right;
	margin: 7px 0 0;
}

.document > .document-heading > .switch > .fa {
	color: #333;
	font-size: 15px;
	font-weight: bold;
}

.document > .document-heading.tn-target-selected > .switch > .fa {
	color: #fff;
	font-size: 15px;
	font-weight: bold;
}

.document > .document-heading. page {
	font-weight: bold;
	color: #FFF !important;
}

.document > .page-selected > h4 > a  {
	font-weight: bold;
	color:  var(--main-primary) !important;
}

.document > .page-selected > .switch > .fa {
	font-size: 15px;
	font-weight: bold;
}

.document > .expanded-page {
    background: linear-gradient(180deg,#eee 0,#fff) !important;
    background-image: linear-gradient(rgb(238, 238, 238) 0px, rgb(255, 255, 255)) !important;
    border: 0px!important;
}
.document > .collapsed-page {
}
.document>.document-heading .page {
    -webkit-box-shadow: inset 0 0 10px #bbb;
    background: #fff;
    border: 0px!important;
    border-top: 1px solid #d5d5d5!important;
}
.document-body > .document-items {
    background: #fff !important;
}

.document.active > .document-heading > .switch > .fa {
	color: #fff;
	font-size: 15px;
	font-weight: bold;
}

.document.active > .document-body {
	background: #fff;
	box-shadow: inset 0px 0px 10px #bbb;
	-moz-box-shadow: inset 0px 0px 10px #bbb;
	-webkit-box-shadow: inset 0px 0px 10px #bbb;
}

.document > .document-heading > .draggable {
	float: left;
	margin-top: 7px;
	margin-left: 2px;
}

.document > .switch {
	float: right;
	display: block;
	margin-top: 5px;
	font-size: 15px;
	font-size: 2.0rem;
	font-weight: bold;
}

.document-items {
	padding: 10px 15px 10px 35px;
}

.document-items:last-child {
	padding-top: 0px;
}

.document-items > .bo-heading {
	overflow: hidden;
}

.document-items > .bo-heading h5 {
	float: left;
	/*width: 45%;  Don't wrap dashboard left-pane detail */
	margin: 0;
	padding: 2px 0;
	
	font-size: 13px;
	font-size: 1.3rem;
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
	color: black;
}

.document-items > .bo-heading .badge {
	background:  var(--main-primary);
	
	color: #fff;
	font-family: "Roboto", "sans-serif";
	font-size: 10px;
	font-size: 1rem;
	font-weight: 500;
	margin-left: 5px;
}

.document-items > .bo-heading .switch {
	float: right;
}

.document-items > .bo-heading .switch .fa {
	color: #333;
	font-size: 18px;
	font-size: 1.8rem;
	font-weight: bold;
}


.document-items > .bo-body ul li {
	padding: 5px 0;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
	list-style: none;
}

.document-items > .bo-body ul li a {
	color: #333;
}

/* Existing behaviors */
.attribute-options li.behavior-options a.active, li.behavior-options  a.active {
	color: #cc7929 !important;
	font-weight: 700;
}

.attribute-options li.behavior-options a:before, li.behavior-options a:before {
	content: '\\f013';
	font-family:"FontAwesome";
	padding-right: 5px;
}

.document-items li.object-selector {
	margin: 0px;
	padding: 0px !important;
	font-size: 11px;
}

/*PF-4918. This is duplicated on PF-4918*/
/* Existing behaviors */
.attribute-options li.behavior-options a.active, li.behavior-options  a.active {
	color: #cc7929 !important;
	font-weight: 700;
}

.attribute-options li.behavior-options a:before, li.behavior-options a:before {
	 content: '\\f013';
	 font-family:"FontAwesome";
	 padding-right: 5px;
 }

 li.behavior-options.no-compatible a:before {
	 content: '\\F12A';
	 font-family: "FontAwesome";
	 padding-right: 7px;
	 margin-left: 3px;
 }

li.behavior-options.no-compatible-red a,
li.behavior-options.no-compatible-red a:hover {
	color: red !important;
	text-decoration: line-through;
}

li.behavior-options.no-compatible-black a,
li.behavior-options.no-compatible-black a:hover {
	color: black !important;
	text-decoration: line-through;
}

.document-items li.object-selector,
.document-items li.behavior-selector {
	margin: 0px;
	padding: 0px !important;
	font-size: 11px;
}

/* Stage Role Area */
.stage-role {
	position: relative;
	margin-bottom: 25px;
	padding-top: 20px;
	padding-right: 15px;
	padding-left: 15px;
	border-top: 1px solid #d5d5d5;
}

.stage-role .row {
	margin-bottom: 4px;
}

.stage-role-items {
	margin: 0;
	padding: 0px 0px 0 25px;
}

.stage-role-items .label {
	display: inline-block;
	padding: 8px 0 0;
	color: #333;
	font-size: 1.2rem;
	font-weight: normal;
	text-align: left;
}

.stage-role-items .links {
	margin: 10px 0 0 0px;
	padding: 0;
}

.stage-role-items .links li {
	padding-right: 10px;
}

.stage-role-items .links li:last-child {
	padding-right: 0px;
}

.stage-role-items .links a {
	color: #333 !important;
	font-size: 13px;
	font-size: 1.3rem;
	font-weight: 500;
	text-decoration: underline;
}

.stage-role-items .links li {
	display: inline-block;
}

.stage-role-items .dropdown-menu{
	max-height: 145px;
	padding-left: 0;
	overflow: auto;
}

/*Filtering Styles*/
#filterResults li.behavior-options,
#filterResults ul.control-list.behavior-options-filter li{
	display: block;
	margin: 0;
	padding-left:13px;
	padding-right:0;
	padding-top:0;
	padding-bottom:0;
	font-size: 11px;
	list-style: none;
	min-width: 190px
}

#filterResults li.page-list{
    list-style: none;
}

#filterResults ul.control-list.behavior-options-filter li a{
	color:#444;
	font-weight:400;
	content:'\\F013'
}

#filterResults ul.control-list.behavior-options-filter li a:hover{
	text-decoration: none
}

#filterResults a{
     cursor: pointer;
}

/*  review this last one */
.attribute-options li a.active:before,
.behavior-options li a.active:before,
.behavior-options-filter li a.active:before,
.behavior-options-filter li a:before{
	content: '\\f013';
	font-family:"FontAwesome";
	padding-right: 5px;
}
.twoColumnsIcon {
	position: relative;
	color:  var(--main-primary) !important;
	width: 20px;
	height: 20px;
	top: 4px;
	right: 0;
	display: block;
}


.eyeIcon {
	position: relative;
	background:  var(--main-primary);
	border-radius: 27px;
	height: 20px;
	min-width: 20px;
	margin: 2px 5px 0 0;
	top: 2px;
}

.eyeIcon svg {
	position: absolute;
	color: white !important;
	width: 15px;
	height: 15px;
	top: 0;
}`, "",{"version":3,"sources":["webpack://./assets/style/partials/left-rail.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,+BAA+B;CAC/B,sBAAsB;CACtB,WAAW;CACX,MAAM;CACN,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,4CAA4C;AAC7C;;AAEA;;CAEC,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;CACV,YAAY;IACT,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,gCAAgC;;IAEhC,mBAAmB;IACnB;yGACqG;IACrG;gFAC4E;IAC5E;6EACyE;IACzE;2EACuE;IACvE;mFAC+E;AACnF;;AAEA;CACC;EACC,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;CACxB;AACD;;AAEA;CACC;EACC;GACC,gBAAgB;GAChB,+BAA+B;GAC/B,4BAA4B;GAC5B,2BAA2B;GAC3B,0BAA0B;GAC1B,uBAAuB;EACxB;CACD;AACD;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,sBAAsB;CACtB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,0CAA0C,EAAE,iBAAiB;CAC7D,4DAA4D,EAAE,aAAa;CAC3E,+DAA+D,EAAE,4BAA4B;CAC7F,gEAAgE,EAAE,qDAAqD;;CAEvH,aAAa;;CAEb,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;CACd,UAAU;CACV,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;IACI,0DAA0D;IAC1D,wFAAwF;IACxF,qBAAqB;AACzB;AACA;AACA;AACA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,qBAAqB;IACrB,uCAAuC;AAC3C;AACA;IACI,2BAA2B;AAC/B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,wCAAwC;CACxC,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,sDAAsD;CACtD,SAAS;CACT,cAAc;;CAEd,eAAe;CACf,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gCAAgC;;CAEhC,WAAW;CACX,mCAAmC;CACnC,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,iBAAiB;AAClB;;;AAGA;CACC,cAAc;CACd,mCAAmC;CACnC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA,uBAAuB;AACvB;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,uBAAuB;CACvB,eAAe;AAChB;;AAEA,yCAAyC;AACzC,uBAAuB;AACvB;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;CACjB;;AAED;;CAEC,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;;CAEC,uBAAuB;CACvB,6BAA6B;AAC9B;;AAEA;;CAEC,WAAW;CACX,uBAAuB;CACvB,eAAe;AAChB;;AAEA,oBAAoB;AACpB;CACC,kBAAkB;CAClB,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,cAAc;AACf;;AAEA,mBAAmB;AACnB;;CAEC,cAAc;CACd,SAAS;CACT,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;CACC,UAAU;CACV,eAAe;CACf;AACD;;AAEA;CACC;AACD;;AAEA;KACK,eAAe;AACpB;;AAEA,0BAA0B;AAC1B;;;;CAIC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,sCAAsC;CACtC,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,QAAQ;CACR,cAAc;AACf;;;AAGA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,mBAAmB;CACnB,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,MAAM;AACP","sourcesContent":[".left-cell {\r\n\tdisplay: table-cell;\r\n\twidth: 319px; \r\n\tvertical-align: top;\r\n\tbackground: #f3f3f3;\r\n\tborder-right: 1px solid #d5d5d5;\r\n\tbox-sizing: border-box;\r\n\tfloat: left;\r\n\ttop: 0;\r\n\tpadding-bottom: 13px;\r\n\tpadding-right: 10px;\r\n}\r\n\r\n.left-rail {\r\n\tposition: relative;\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n\tpadding: 0;\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\tfont-size: 1.3rem; \r\n}\r\n\r\n.left-rail .dropdown button {\r\n\theight: 25px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n#thumbnail-pane .ui-resizable-e  {\r\n\tright: 0 !important;\r\n\twidth: 10px !important;\r\n\tbackground: rgba(94,140,38, 0.10) !important;\r\n}\r\n\r\n.right-cell .ui-resizable-w  .handler, \r\n#thumbnail-pane .ui-resizable-e .handler {\r\n\tborder-right: 2px;\r\n\tborder-left: 2px;\r\n\twidth: 5px; \r\n\theight: 50px; \r\n    position: relative;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-right: -50%;\r\n    transform: translate(-50%, -50%); \r\n    \r\n    border-style: solid;\r\n    -webkit-border-image: \r\n      -webkit-gradient(linear, 0 0, 0 100%, from(var(--main-secondary)), to(var(--main-primary))) 10 100%;\r\n    -webkit-border-image: \r\n      -webkit-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;\r\n    -moz-border-image:\r\n      -moz-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;    \r\n    -o-border-image:\r\n      -o-linear-gradient(var(--main-secondary), var(--main-primary)) 0 100%;\r\n    border-image:\r\n      linear-gradient(to bottom, var(--main-secondary), var(--main-primary)) 0 100%;\r\n}\r\n\r\n@-moz-document url-prefix() {\r\n\t.left-rail {\r\n\t\t/*height: 87vh;*/\r\n\t\t-webkit-transition: height 0.5s;\r\n\t\t-moz-transition: height 0.5s;\r\n\t\t-ms-transition: height 0.5s;\r\n\t\t-o-transition: height 0.5s;\r\n\t\ttransition: height 0.5s;\r\n\t}\r\n}\r\n\r\n@media screen and (max-height: 1200px) {\r\n\t@-moz-document url-prefix() {\r\n\t\t.left-rail {\r\n\t\t\t/*height: 77vh;*/\r\n\t\t\t-webkit-transition: height 0.5s;\r\n\t\t\t-moz-transition: height 0.5s;\r\n\t\t\t-ms-transition: height 0.5s;\r\n\t\t\t-o-transition: height 0.5s;\r\n\t\t\ttransition: height 0.5s;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.search-filter {\r\n\tpadding: 0;\r\n}\r\n\r\n.search-filter .search-box {\r\n\twidth: 100%;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.filter-forms .dropdown {\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.add-page-expcol {\r\n\tpadding: 7px 0 9px 10px;\r\n\toverflow: hidden;\r\n\tbackground: #ffffff;\r\n}\r\n\r\n.add-page-expcol .btn {\r\n\ttext-align:left;\r\n}\r\n\r\n.add-page-expcol .btn:first-child {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.add-page-expcol .btn i {\r\n\tfont-size: 1.3rem;\r\n\tfont-weight: bold;\r\n\tvertical-align: middle;\r\n\tcolor: #799F3F;\r\n\tmargin-right: 3px;\r\n}\r\n\r\n.document-group {\r\n\tmargin: 20px 0 0;\r\n}\r\n\r\n.document > .document-heading {\r\n\tpadding: 0 15px;\r\n\tbackground: #f3f3f3;\r\n\tborder-top: 1px solid #d5d5d5;\r\n\toverflow: hidden;\r\n}\r\n\r\n.document.active > .document-heading {\r\n\tbackground: var(--main-primary) !important; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(var(--gradient)) !important; /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(var(--gradient)) !important; /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(var(--gradient-ToBottom)) !important; /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\t\r\n\tborder-top: 0;\r\n\t\r\n\tcolor: #fff;\r\n}\r\n\r\n.document > .document-heading > h4 {\r\n\tfloat: left;\r\n\tmargin-top: 6px;\r\n\tmargin-left: 15px;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n\tfont-size: 1.4rem;\r\n\tletter-spacing: 0.2px;\r\n\tmax-width: 85%;\r\n\twidth: 85%;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n}\r\n\r\n.document > .document-heading > h4 > a {\r\n\tcolor: #333;\r\n}\r\n\r\n.document > .document-heading > h4 > a:visited, .document > .document-heading > h4 > a:active {\r\n\ttext-decoration: none !important;\r\n}\r\n\r\n.document > .document-heading > h4 > a:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n\r\n.document.active > .document-heading > h4 > a {\r\n\tcolor: #fff;\r\n}\r\n\r\n.document > .document-heading .switch {\r\n\tfloat: right;\r\n\tmargin: 7px 0 0;\r\n}\r\n\r\n.document > .document-heading > .switch > .fa {\r\n\tcolor: #333;\r\n\tfont-size: 15px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document > .document-heading.tn-target-selected > .switch > .fa {\r\n\tcolor: #fff;\r\n\tfont-size: 15px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document > .document-heading. page {\r\n\tfont-weight: bold;\r\n\tcolor: #FFF !important;\r\n}\r\n\r\n.document > .page-selected > h4 > a  {\r\n\tfont-weight: bold;\r\n\tcolor:  var(--main-primary) !important;\r\n}\r\n\r\n.document > .page-selected > .switch > .fa {\r\n\tfont-size: 15px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document > .expanded-page {\r\n    background: linear-gradient(180deg,#eee 0,#fff) !important;\r\n    background-image: linear-gradient(rgb(238, 238, 238) 0px, rgb(255, 255, 255)) !important;\r\n    border: 0px!important;\r\n}\r\n.document > .collapsed-page {\r\n}\r\n.document>.document-heading .page {\r\n    -webkit-box-shadow: inset 0 0 10px #bbb;\r\n    background: #fff;\r\n    border: 0px!important;\r\n    border-top: 1px solid #d5d5d5!important;\r\n}\r\n.document-body > .document-items {\r\n    background: #fff !important;\r\n}\r\n\r\n.document.active > .document-heading > .switch > .fa {\r\n\tcolor: #fff;\r\n\tfont-size: 15px;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document.active > .document-body {\r\n\tbackground: #fff;\r\n\tbox-shadow: inset 0px 0px 10px #bbb;\r\n\t-moz-box-shadow: inset 0px 0px 10px #bbb;\r\n\t-webkit-box-shadow: inset 0px 0px 10px #bbb;\r\n}\r\n\r\n.document > .document-heading > .draggable {\r\n\tfloat: left;\r\n\tmargin-top: 7px;\r\n\tmargin-left: 2px;\r\n}\r\n\r\n.document > .switch {\r\n\tfloat: right;\r\n\tdisplay: block;\r\n\tmargin-top: 5px;\r\n\tfont-size: 15px;\r\n\tfont-size: 2.0rem;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document-items {\r\n\tpadding: 10px 15px 10px 35px;\r\n}\r\n\r\n.document-items:last-child {\r\n\tpadding-top: 0px;\r\n}\r\n\r\n.document-items > .bo-heading {\r\n\toverflow: hidden;\r\n}\r\n\r\n.document-items > .bo-heading h5 {\r\n\tfloat: left;\r\n\t/*width: 45%;  Don't wrap dashboard left-pane detail */\r\n\tmargin: 0;\r\n\tpadding: 2px 0;\r\n\t\r\n\tfont-size: 13px;\r\n\tfont-size: 1.3rem;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n\tcolor: black;\r\n}\r\n\r\n.document-items > .bo-heading .badge {\r\n\tbackground:  var(--main-primary);\r\n\t\r\n\tcolor: #fff;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 10px;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 500;\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.document-items > .bo-heading .switch {\r\n\tfloat: right;\r\n}\r\n\r\n.document-items > .bo-heading .switch .fa {\r\n\tcolor: #333;\r\n\tfont-size: 18px;\r\n\tfont-size: 1.8rem;\r\n\tfont-weight: bold;\r\n}\r\n\r\n\r\n.document-items > .bo-body ul li {\r\n\tpadding: 5px 0;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n\tlist-style: none;\r\n}\r\n\r\n.document-items > .bo-body ul li a {\r\n\tcolor: #333;\r\n}\r\n\r\n/* Existing behaviors */\r\n.attribute-options li.behavior-options a.active, li.behavior-options  a.active {\r\n\tcolor: #cc7929 !important;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.attribute-options li.behavior-options a:before, li.behavior-options a:before {\r\n\tcontent: '\\f013';\r\n\tfont-family:\"FontAwesome\";\r\n\tpadding-right: 5px;\r\n}\r\n\r\n.document-items li.object-selector {\r\n\tmargin: 0px;\r\n\tpadding: 0px !important;\r\n\tfont-size: 11px;\r\n}\r\n\r\n/*PF-4918. This is duplicated on PF-4918*/\r\n/* Existing behaviors */\r\n.attribute-options li.behavior-options a.active, li.behavior-options  a.active {\r\n\tcolor: #cc7929 !important;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.attribute-options li.behavior-options a:before, li.behavior-options a:before {\r\n\t content: '\\f013';\r\n\t font-family:\"FontAwesome\";\r\n\t padding-right: 5px;\r\n }\r\n\r\n li.behavior-options.no-compatible a:before {\r\n\t content: '\\F12A';\r\n\t font-family: \"FontAwesome\";\r\n\t padding-right: 7px;\r\n\t margin-left: 3px;\r\n }\r\n\r\nli.behavior-options.no-compatible-red a,\r\nli.behavior-options.no-compatible-red a:hover {\r\n\tcolor: red !important;\r\n\ttext-decoration: line-through;\r\n}\r\n\r\nli.behavior-options.no-compatible-black a,\r\nli.behavior-options.no-compatible-black a:hover {\r\n\tcolor: black !important;\r\n\ttext-decoration: line-through;\r\n}\r\n\r\n.document-items li.object-selector,\r\n.document-items li.behavior-selector {\r\n\tmargin: 0px;\r\n\tpadding: 0px !important;\r\n\tfont-size: 11px;\r\n}\r\n\r\n/* Stage Role Area */\r\n.stage-role {\r\n\tposition: relative;\r\n\tmargin-bottom: 25px;\r\n\tpadding-top: 20px;\r\n\tpadding-right: 15px;\r\n\tpadding-left: 15px;\r\n\tborder-top: 1px solid #d5d5d5;\r\n}\r\n\r\n.stage-role .row {\r\n\tmargin-bottom: 4px;\r\n}\r\n\r\n.stage-role-items {\r\n\tmargin: 0;\r\n\tpadding: 0px 0px 0 25px;\r\n}\r\n\r\n.stage-role-items .label {\r\n\tdisplay: inline-block;\r\n\tpadding: 8px 0 0;\r\n\tcolor: #333;\r\n\tfont-size: 1.2rem;\r\n\tfont-weight: normal;\r\n\ttext-align: left;\r\n}\r\n\r\n.stage-role-items .links {\r\n\tmargin: 10px 0 0 0px;\r\n\tpadding: 0;\r\n}\r\n\r\n.stage-role-items .links li {\r\n\tpadding-right: 10px;\r\n}\r\n\r\n.stage-role-items .links li:last-child {\r\n\tpadding-right: 0px;\r\n}\r\n\r\n.stage-role-items .links a {\r\n\tcolor: #333 !important;\r\n\tfont-size: 13px;\r\n\tfont-size: 1.3rem;\r\n\tfont-weight: 500;\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.stage-role-items .links li {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.stage-role-items .dropdown-menu{\r\n\tmax-height: 145px;\r\n\tpadding-left: 0;\r\n\toverflow: auto;\r\n}\r\n\r\n/*Filtering Styles*/\r\n#filterResults li.behavior-options,\r\n#filterResults ul.control-list.behavior-options-filter li{\r\n\tdisplay: block;\r\n\tmargin: 0;\r\n\tpadding-left:13px;\r\n\tpadding-right:0;\r\n\tpadding-top:0;\r\n\tpadding-bottom:0;\r\n\tfont-size: 11px;\r\n\tlist-style: none;\r\n\tmin-width: 190px\r\n}\r\n\r\n#filterResults li.page-list{\r\n    list-style: none;\r\n}\r\n\r\n#filterResults ul.control-list.behavior-options-filter li a{\r\n\tcolor:#444;\r\n\tfont-weight:400;\r\n\tcontent:'\\F013'\r\n}\r\n\r\n#filterResults ul.control-list.behavior-options-filter li a:hover{\r\n\ttext-decoration: none\r\n}\r\n\r\n#filterResults a{\r\n     cursor: pointer;\r\n}\r\n\r\n/*  review this last one */\r\n.attribute-options li a.active:before,\r\n.behavior-options li a.active:before,\r\n.behavior-options-filter li a.active:before,\r\n.behavior-options-filter li a:before{\r\n\tcontent: '\\f013';\r\n\tfont-family:\"FontAwesome\";\r\n\tpadding-right: 5px;\r\n}\r\n.twoColumnsIcon {\r\n\tposition: relative;\r\n\tcolor:  var(--main-primary) !important;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\ttop: 4px;\r\n\tright: 0;\r\n\tdisplay: block;\r\n}\r\n\r\n\r\n.eyeIcon {\r\n\tposition: relative;\r\n\tbackground:  var(--main-primary);\r\n\tborder-radius: 27px;\r\n\theight: 20px;\r\n\tmin-width: 20px;\r\n\tmargin: 2px 5px 0 0;\r\n\ttop: 2px;\r\n}\r\n\r\n.eyeIcon svg {\r\n\tposition: absolute;\r\n\tcolor: white !important;\r\n\twidth: 15px;\r\n\theight: 15px;\r\n\ttop: 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
